<template>
  <div class="viewcontent" v-if="translations.pay">
    <h1>{{ translations.pay.title_error }}</h1>
    <img :src="require('@/assets/icon/shopping_cart_alert.svg')" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'Pay Error',
    computed: {
      ...mapState(['translations']),
    },
  }
</script>

<style></style>
